var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.446 6.806H9.699L12.984 0h-7.44L.554 12.046h6.137L5.22 20 15.445 6.806zm-12.55 3.676l3.693-8.918h3.903L7.206 8.37h5.048L7.93 13.95l.641-3.468H2.896z",
    fill: "url(#flash_svg__paint0_linear_6376_98468)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flash_svg__paint0_linear_6376_98468",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/flash.1ea51bda56cab948841c1bd89677589b.svg";
export { SvgFlash as ReactComponent };